import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import useAuth from "../../hooks/useAuth";
import "./Dashboard2/Dashboard2.css";

const RunningCampaigns = (props) => {
    const { auth } = useAuth();

    const [selectingId, setSelectingId] = useState(null);

    const closePopUp = async () => {
        props.close(false)
        props.setCamps(false)
    }

    const chooseCampaign = async (camp) => {
        if (selectingId) return;

        setSelectingId(camp.id);

        let post_data = {
            user_id: auth?.user_details?.id,
            camp_id: camp.id,
        };

        let config = {
            headers: { "Content-Type": "application/json" },
        };

        try {
            await axios.post(
                process.env.REACT_APP_API_URL + "/contactcentre/update_current_campaign/",
                post_data,
                config
            )

            props.close(false)
            props.setCamps(false)
        } catch (err) {
            Swal.fire({
                title: "Campaign Selection Failed",
                text: "Unable to set your campaign. Please try again",
                confirmButtonColor: "#3085d6",
                icon: "warning",
            });
        } finally {
            setSelectingId(null);
        }
    }

    const campaigns = props.live_campaigns || [];

    return (
        <div className="dash2 campaign-picker">
            <div className="campaign-picker-head">
                <h3>Choose Running Campaign</h3>
                <button
                    type="button"
                    className="campaign-picker-close"
                    onClick={closePopUp}
                >
                    ×
                </button>
            </div>
            <div className="campaign-picker-list">
                {campaigns.length === 0 ? (
                    <div className="empty-state">No running campaigns to show.</div>
                ) : (
                    campaigns.map((camp) => {
                        const isSelecting = selectingId === camp.id;
                        const isDisabled = selectingId !== null && !isSelecting;
                        return (
                            <div
                                key={camp.id}
                                className={`campaign-picker-item${isDisabled ? " disabled" : ""}`}
                                onClick={() => chooseCampaign(camp)}
                            >
                                <div className="campaign-picker-item-main">
                                    <div className="campaign-picker-item-name">{camp.name}</div>
                                </div>
                                {isSelecting ? (
                                    <span className="campaign-picker-badge loading">Selecting…</span>
                                ) : (
                                    <span className="campaign-picker-select">Select</span>
                                )}
                            </div>
                        );
                    })
                )}
            </div>
        </div>
    )
}
export default React.memo(RunningCampaigns);
